import { getTrackingUUID } from 'src/dataLayer/localData/cookies';
import { HeadersInit } from './types';

export default (): HeadersInit => ({
  'Content-Type': 'application/json',
  'X-Babbel-Tracking-UUID': getTrackingUUID() as string
});
